/**
 * OVA homepage: product picker dialog.
 * Uses the native <dialog> element (focus trap, Escape and focus return are built in);
 * this file only wires the triggers, closes on backdrop click and animates the exit.
 */
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function closePicker(dialog) {
  if (!dialog.open || dialog.classList.contains('is-closing')) return;
  if (reducedMotion.matches) {
    dialog.close();
    return;
  }
  dialog.classList.add('is-closing');
  dialog.addEventListener(
    'animationend',
    () => {
      dialog.classList.remove('is-closing');
      dialog.close();
    },
    { once: true }
  );
}

function setup(scope = document) {
  scope.querySelectorAll('.ova-home').forEach((home) => {
    if (home.dataset.ovaPickerReady) return;
    home.dataset.ovaPickerReady = 'true';

    const dialog = document.getElementById(`OvaProductPicker-${home.dataset.sectionId}`);
    if (!(dialog instanceof HTMLDialogElement)) return;

    home.querySelectorAll('[data-ova-open-product-picker]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        dialog.showModal();
        document.documentElement.classList.add('ova-scroll-lock');
      });
    });

    dialog.querySelector('[data-ova-close-product-picker]')?.addEventListener('click', () => closePicker(dialog));

    // Click on the backdrop (the dialog element itself, outside the panel) closes it.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closePicker(dialog);
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePicker(dialog);
    });

    dialog.addEventListener('close', () => document.documentElement.classList.remove('ova-scroll-lock'));
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
else setup();

document.addEventListener('shopify:section:load', (event) => setup(event.target));
